import { render } from "./FleetIcon.vue?vue&type=template&id=24064f42"
import script from "./FleetIcon.vue?vue&type=script&lang=js"
export * from "./FleetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__